export default __webpack_public_path__ + "static/media/who.0bde2933.svg";